// specifically for the integration section of the Edit Account page
export enum StatusType {
	normal = 'normal',
	caution = 'caution',
	error = 'error'
};

// used a a global status for the Integrations
export enum IntegrationStatusType {
	UNKNOWN = 0,
	GOOD,
	INFO,
	ERROR  
}

